// src/auth/comptePartage.ts — SCE Issues
// Qui tient l'appareil partagé, retenu sur l'appareil (07/10).
//
// Un compte partagé (config/comptesAlias.config, comptesPartages()) ne dit pas
// qui s'en sert : on le demande à l'ouverture, puis on le retient dans le
// localStorage — l'appareil est protégé par un code que seuls ses utilisateurs
// connaissent, rien de plus à protéger ici. Clé par Object ID : un autre
// compte connecté sur le même navigateur n'hérite de rien.
//
// Changer de personne recharge la page : préférences, suivis, identifiant
// SharePoint, réglages du tableau… sont gardés en mémoire PAR personne dans
// des dizaines de hooks. Repartir de zéro est plus sûr que d'en oublier un.

const PREFIXE = 'sce-issues:personne-appareil:'

/**
 * Object ID du compte partagé connecté dans cet onglet, noté par la garde
 * (GardeComptePartage). Les API le lisent pour signer leurs écritures
 * (colonne SaisiPar) sans dépendre de MSAL ni de React.
 */
let appareilPartage: string | null = null

export function noterAppareilPartage(objectId: string | null): void {
  appareilPartage = objectId
}

/**
 * Ce qu'il faut ajouter à une ligne créée dans SCE_Problemes ou
 * SCE_Commentaires : `{ SaisiPar: upn }` depuis un appareil partagé, rien
 * sinon — la colonne ne sert qu'à dire QUI tenait l'appareil, SharePoint
 * ne voyant que son compte (Author).
 */
export function colonneSaisiPar(): { SaisiPar?: string } {
  const upn = appareilPartage ? personneChoisie(appareilPartage) : null
  return upn ? { SaisiPar: upn } : {}
}

/** UPN de la personne choisie sur cet appareil pour ce compte, ou null. */
export function personneChoisie(objectId: string): string | null {
  try {
    return localStorage.getItem(PREFIXE + objectId.toLowerCase())
  } catch {
    return null
  }
}

export function retenirPersonne(objectId: string, upn: string): void {
  try {
    localStorage.setItem(PREFIXE + objectId.toLowerCase(), upn)
  } catch {
    // Stockage refusé : la question reviendra au prochain chargement.
  }
}

/** Passe à une autre personne : retenue, puis la page repart avec elle. */
export function changerDePersonne(objectId: string, upn: string): void {
  retenirPersonne(objectId, upn)
  window.location.reload()
}

/** À la déconnexion : le prochain qui se connecte dira qui il est. */
export function oublierPersonnes(): void {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const cle = localStorage.key(i)
      if (cle?.startsWith(PREFIXE)) localStorage.removeItem(cle)
    }
  } catch {
    // Rien à faire.
  }
}
